import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

// everything that shows a bundle's check or reclassification
export const useQualityCheckRefresh = () => {
	const queryClient = useQueryClient();
	return useCallback(async () => {
		await Promise.all(
			["sawQualityChecks", "sawRecentBundles", "bundleReclassification"].map(
				(key) => queryClient.invalidateQueries({ queryKey: [key] }),
			),
		);
	}, [queryClient]);
};
